import { HydrateAction, hydrateType } from '../HydrateAction';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ExperimentsState } from '@spa/lib/store/experiments/ExperimentsState';

const initialState: ExperimentsState = {
  activeExperiments: []
};

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    setActiveExperiments(state, { payload }: PayloadAction<ReadonlyArray<string>>) {
      state.activeExperiments = [...payload];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrateType, (state, action: HydrateAction) => {
        if (action.payload.experiments) {
          state.activeExperiments = [...action.payload.experiments.activeExperiments];
        }
      })
      .addDefaultCase(() => {});
  }
});

export const { setActiveExperiments } = experimentsSlice.actions;

export default experimentsSlice.reducer;
